module.exports = __webpack_public_path__ + "img/izibox.004a3a4a.png";